module.exports = __webpack_public_path__ + "media/images/corporate-logos/logo-quicken-6fd3f762eb5d9e7065221cb4ea7052b8.svg";